Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

    /* This Concern helps improve accessibility to our views for widgets and the uploader.
     *
     * Add general helper functions and event listeners here which can be referenced for desktop and mobile.
     * TODO: combine tabindexHelpers into this concern
     *
     * Note: Lightbox accessibility is handled separately since it does not reference concerns/behaviors in Marionette.
     */

    Concerns.AccessibilityHelpers = {
        // elements in a view that should be identified for assistive technologies
        focusableElementsArray: [
            'a[href]',
            'area[href]',
            'button:not([disabled])',
            'embed',
            'iframe',
            'input:not([type="hidden"]):not([tabindex="-1"]):visible',
            'object',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[contenteditable]',
            '[tabindex]:not([tabindex="-1"]):visible'
        ],

        initialize: function() {
            document.body.onload = function(){

                document.body.addEventListener('mousedown', function(e) {
                    // remove keyboard class if it exists
                    if (document.body.classList.contains('using-keyboard')) {
                        document.body.classList.remove('using-keyboard');
                    }
                    // add mouse class
                    document.body.classList.add('using-mouse');
                });

                document.body.addEventListener('keydown', function(e) {
                    // remove mouse class if it exists
                    if (document.body.classList.contains('using-mouse')) {
                        document.body.classList.remove('using-mouse');
                    }
                    // add keyboard class
                    document.body.classList.add('using-keyboard');
                });
            };
        },

        onShow: function() {
            this.preventScrollPolyfill();
        },

        /**
         * For turning an HTML collection into an array of focusable elements
         * e.g. the breadcrumbs and each panel section in uploader: ['this.ui.breadcrumbs', 'this.ui.homePanel']
         *
         * @param  {Array}  elements    Collection of HTML elements
         * @return {Array}  focusIndex  Focusable elements that a keyboard user can tab through (e.g. ['div.breadcrumb', 'button', 'button', 'button', 'button'])
         */
        createFocusIndex: function(elements) {
            var focusableElements = [];
            var focusIndex = [];

            _.each(elements, function(el) {
                var validElements = $(el).find(this.focusableElementsArray.join());
                var elementsArray = Array.prototype.slice.call(validElements);
                focusableElements.push(elementsArray);
            }.bind(this));

            focusIndex = [].concat.apply([], focusableElements);

            return focusIndex;
        },

        /**
         * For determining which element to focus on in a modal;
         * allows users to cycle through all accessible elements when pressing tab
         * @param  {Object}  e         Keyboard event
         * @param  {Array}   elements  Array of focusable HTML elements
         * @param  {Number}  index     Index of current element in focus
         */
        cycleTab: function(e, elements, index) {
            // if on the last element of the focus index and user tabs forwards (tab)
            if (_.isFalsy(e.shiftKey) && index === elements.length - 1) {
                e.preventDefault();
                elements[0].focus();
            }

            // if on the first element of the focus index and user tabs backwards (tab + shift)
            if (_.isTruthy(e.shiftKey) && index === 0) {
                e.preventDefault();
                elements[elements.length - 1].focus();
            }
        },

        /**
         * For interacting with elements via keyboard;
         * Example: this is a helper function which will map events to
         * interactive elements that aren't marked up as buttons, etc
         * @param  {Object}  e  Keyboard event
         *
         */
        mapKeyboardInteractionToElements: function(e) {
            /* ENTER */
            if (e.keyCode === 13) {
                e.preventDefault();
                e.target.click();
            }
        },

        /**
         * Sets the tabindex attribute of an array of HTML elements (e.g. tabindex="0")
         * @param  {Array}   elementsArray  Array of elements
         * @param  {String}  index          Number value (e.g. 1, 0, -1)
         */
        setTabindexOfElements: function(elementsArray, index) {
            // hide focus of elements behind alert box
            _.each(elementsArray, function(el) {
                $(el).attr('tabindex', index.toString());
            });
        },

        /* preventScroll polyfill if not supported by browser
         * taken from: https://github.com/calvellido/focus-options-polyfill/blob/master/index.js
         */
        preventScrollPolyfill: function() {
            if (typeof window === "undefined" ||
                typeof document === "undefined" ||
                typeof HTMLElement === "undefined"
            ) {
                return;
            }

            var supportsPreventScrollOption = false;
            try {
                var focusElem = document.createElement("div");
                focusElem.addEventListener(
                    "focus",
                    function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }, true);
                focusElem.focus(
                    Object.defineProperty({}, "preventScroll", {
                        get: function() {
                            supportsPreventScrollOption = true;
                        }
                    })
                );
            } catch (e) {}

            if (HTMLElement.prototype.nativeFocus === undefined &&
                !supportsPreventScrollOption) {
                HTMLElement.prototype.nativeFocus = HTMLElement.prototype.focus;

                var calcScrollableElements = function(element) {
                    var parent = element.parentNode;
                    var scrollableElements = [];
                    var rootScrollingElement = document.scrollingElement || document.documentElement;

                    while (parent && parent !== rootScrollingElement) {
                            if (parent.offsetHeight < parent.scrollHeight ||
                                parent.offsetWidth < parent.scrollWidth) {
                                scrollableElements.push([
                                parent,
                                parent.scrollTop,
                                parent.scrollLeft
                                ]);
                            }
                        parent = parent.parentNode;
                    }
                    parent = rootScrollingElement;
                    scrollableElements.push([parent, parent.scrollTop, parent.scrollLeft]);

                    return scrollableElements;
                };

                var restoreScrollPosition = function(scrollableElements) {
                    for (var i = 0; i < scrollableElements.length; i++) {
                        scrollableElements[i][0].scrollTop = scrollableElements[i][1];
                        scrollableElements[i][0].scrollLeft = scrollableElements[i][2];
                    }
                    scrollableElements = [];
                };

                var patchedFocus = function(args) {
                    if (args && args.preventScroll) {
                        var evScrollableElements = calcScrollableElements(this);
                        this.nativeFocus();
                        restoreScrollPosition(evScrollableElements);
                    }
                    else {
                        this.nativeFocus();
                    }
                };

                HTMLElement.prototype.focus = patchedFocus;
            }
        }
    };
});
